<template lang="pug">
  .trace-package
    .panel.panel-default
      .panel-heading.panel-title Package Details
      .panel-body
        dt Product
        router-link(v-if="product" :to="{ name: 'product', params: { id: product.productId }}") {{ product.name }}
        em.text-muted(v-else) no product
        dt Package Name
        router-link(:to="{ name: 'packageEdit', params: { id: package.packageType.id }}") {{ package.packageType.name }}

        dt Package Type
        dd {{ package.packageType.type }}

        dt Order
        router-link(:to="{ name: 'order', params: { id: package.orderId }}") {{ package.orderId }}
        router-link(:to="{ name: 'orderMetadata', params: { id: package.orderId }}") , Metadata

        dt Section
        div(v-if="sectionId")
          router-link(:to="{ name: 'section', params: { orderId: package.orderId, sectionId }}") {{ sectionId }}
          router-link(:to="{ name: 'sectionMetadata', params: { orderId: package.orderId, sectionId }}") , Metadata
        div(v-else)
          em.text-muted no section

</template>

<script>
import Core from '@/service/apis/Core'

export default {
  props: {
    package: {
      type: Object,
      required: true
    },
    product: {
      type: Object
    }
  },
  data: () => ({
    sectionId: null
  }),
  created() {
    Core.batchValidate({ codes: [this.package.code] })
      .then((resp) => {
        this.sectionId = resp.data[0].section.id
      })
  },
}
</script>



// WEBPACK FOOTER //
// src/components/pages/trackntrace/dashboards/trace/components/PackageDetails.vue